<template>
  <div class="train-detail-container">
    <div class="myintergral">
      <div class="top">
        <div class="jifen1">可用积分</div>
        <div class="jifen2">{{ jifen }}</div>
        <span class="word11">即将过期积分：{{integral}}积分</span>
      </div>
    </div>
    <div class="content">积分明细</div>
    <div class="btooom">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="item in list" :key="item.id">
          <div class="listcont">
            <div class="listcont-left">{{ item.reason }}</div>
            <div
              class="listcont-right"
              :style="item.type == 1 ? 'color:#2DCA39' : 'color:#f4290d'"
            >
              {{ item.type == 1 ? "+" + item.value : "-" + item.value }}
            </div>
          </div>
          <div class="listbom">{{ deteFormat(item.createTime) }}</div>
        </van-cell>
      </van-list>
    </div>
    <!-- <van-nav-bar
        title=""
        left-arrow
        left-text="返回"
        @click-left="returnMy"
    >
    </van-nav-bar> -->
    <!-- <h2 class="integral-number">{{integralNumber}}</h2>
    <h2 class="van-doc-demo-block__title">积分明细</h2>
    <van-steps direction="vertical" :active="-1">
      <van-step v-for="(item,index) in recordList" :key="index">
        <h3>{{item.typeName}}</h3>
        <p>{{item.createTime}}</p>
      </van-step>
    </van-steps> -->
  </div>
</template>

<script>
// import { Button, Step, Steps, NavBar } from 'vant'
import {
  Search,
  DropdownMenu,
  DropdownItem,
  Button,
  CellGroup,
  Cell,
  List,
  NavBar,
  Image,
} from "vant";
import api from "@/api";

export default {
  components: {
    [Search.name]: Search,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [List.name]: List,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
  },

  data() {
    return {
      integral:2000,
      
      list: [],
      loading: false,
      finished: false,
      recordList: [],
      // 分页，每页显示10条
      limit: 10,
      // 分页列表总页数
      totalPage: 0,
      // 分页列表当前页码
      page: 0,
      list2: [],
      jifen:'',
      integralNumber: 1000000,
    };
  },
  mounted() {
    this.getjifen()
    api.train.getMyExpireIntegral().then((res)=>{
      if(res.code == 0){
        this.integral=res.data
      }
    })
    // this.getList();
  },
  methods: {
    // 处理时间
    deteFormat(dateDate) {
      const date = new Date(dateDate);
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let f = date.getMinutes();
      f = f < 10 ? "0" + f : f;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      const time = y + "/" + m + "/" + d + "/" + h + ":" + f + ":" + s;
      return time;
    },
    onLoad() {
      this.page += 1;
      this.findlist();
    },
    findlist() {
      let data = {
        page: this.page,
        limit: this.limit,
      };
      api.train.pageMyUsableIntegral(data).then((res) => {
        if (res.msg === "success") {
          if (this.page === 1) {
            this.list = res.data;
          } else {
            this.list = [...this.list, ...res.data];
          }
          this.totalPage = res.count;
          this.list2 = res.data;
          this.loading = false;
          if (this.list.length == res.count) {
            this.finished = true;
          }
        } else {
          this.$toast.fail({
            message: "报错了",
          });
        }
      });
    },
    // 获取积分
    getjifen() {
      api.train.getMyUsableIntegral().then((res) => {
        if (res.msg == "success") {
          this.jifen = res.data;
        }
      });
    },
    returnMy() {
      this.$router.replace({
        path: "/layout",
        query: {
          active: "personal",
        },
      });
    },
  },
};
</script>
<style lang="less">
</style>
<style lang="less" scoped>
.train-detail-container {
  background: #f8f8f8;
  height: 100%;
  .myintergral {
    // margin-top: 2rem;
    // width: 92%;
    // height: 14rem;
    background: #f8f8f8;
    display: flex;
    justify-content: center;
    align-items: center;
    .top {
      width: 92%;
      height: 9.5rem;
      margin-top: 1rem;
      background: #fff;
      background-image: url("../../assets/img/jifen.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      // background-repeat:
      .jifen1 {
        color: rgba(255, 255, 255, 0.6);
        font-size: 12px;
        margin-top: 1.5rem;
        margin-left: 1.2rem;
      }
      .jifen2 {
        margin-top: 0.6rem;
        margin-left: 1.2rem;
        font-weight: 600;
        color: #ffffff;
        font-size: 7.199vw;
        // font-size: 1.5rem;
      }
      .word11 {
        
        z-index: 43;
        position: absolute;
        right: 3.8vw;
        top: 7rem;
        width: 87.199vw;
        // height: 5.866vw;
        display: block;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 0.6);
        font-size: 3.5vw;
        white-space: nowrap;
        // line-height: 5.8666vw;
      }
    }
  }
  .content {
    margin-left: 1rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
    color: #222222;
    font-size: 16px;
  }
  .btooom {
    display: flex;
    justify-content: center;
    .van-list {
      background: #f8f8f8;
      width: 96%;
      .listcont {
        height: 3rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .listcont-left {
          font-weight: 400;
          color: #222222;
          // font-size: 1.1rem;
          font-size: 16px;
        }
        .listcont-right {
          font-size: 1rem;
          // color: #f4290d;
          font-size: 16px;
        }
      }
      .listbom {
        // font-size: 0.8rem;
        font-size: 12.5px;
        color: #999999;
        margin-bottom: 0.5rem;
      }
    }
  }
}
.van-doc-demo-block__title {
  margin: 0;
  padding: 32px 16px 16px;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
}
.integral-number {
  text-align: center;
}
</style>
